import { render, staticRenderFns } from "./paySuccess.vue?vue&type=template&id=3981ffc0&scoped=true&"
import script from "./paySuccess.vue?vue&type=script&lang=js&"
export * from "./paySuccess.vue?vue&type=script&lang=js&"
import style0 from "./paySuccess.vue?vue&type=style&index=0&id=3981ffc0&lang=less&scoped=true&"
import style1 from "./paySuccess.vue?vue&type=style&index=1&id=3981ffc0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3981ffc0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3981ffc0')) {
      api.createRecord('3981ffc0', component.options)
    } else {
      api.reload('3981ffc0', component.options)
    }
    module.hot.accept("./paySuccess.vue?vue&type=template&id=3981ffc0&scoped=true&", function () {
      api.rerender('3981ffc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/shop/paySuccess.vue"
export default component.exports